import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import SkuflixShare3Icon from "core/icons/skuflix/SkuflixShare3Icon";
import { useTranslation } from "react-i18next";
import { shareURL } from "@telegram-apps/sdk";
import { isTelegramMiniApp } from "core/utils/telegram";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function ShareButton({
  shareData,
  fullWidth = false,
  isInviteMode = false,
  compact = false,
}) {
  const { t } = useTranslation("arena");
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const isCompact = compact && !sm;

  if (!process.browser) return null;
  if (process.env.NODE_ENV === "production") {
    if (isTelegramMiniApp) {
      if (!shareURL.isAvailable()) {
        return null;
      }
    } else {
      if (!("share" in navigator)) return null;
    }
  }

  const sharePayload = isInviteMode
    ? {
        url: shareData.url,
        title: t("shareButton.inviteTitle", { title: shareData.title }),
        text: t("shareButton.inviteText", { title: shareData.title }),
      }
    : shareData;

  const onClick = () => {
    console.log("[ShareButton] onClick", {
      isTelegramMiniApp,
      isInviteMode,
      shareData,
    });

    if (isTelegramMiniApp) {
      const text = isInviteMode
        ? t("shareButton.telegramInviteText", { title: shareData.title })
        : sharePayload.title;

      console.log("[ShareButton] Telegram shareURL", {
        url: sharePayload.url,
        text,
      });
      return shareURL(sharePayload.url, text);
    }

    console.log("[ShareButton] navigator.share", sharePayload);
    navigator.share(sharePayload);
  };

  return (
    <Button
      fullWidth={fullWidth}
      variant="text"
      color="inherit"
      startIcon={
        <SkuflixShare3Icon sx={isCompact ? { fontSize: 18 } : undefined} />
      }
      size={isCompact ? "small" : sm ? "large" : "medium"}
      onClick={onClick}
      sx={{
        borderRadius: 0,
        pr: isCompact ? 1 : 1.5,
        whiteSpace: "nowrap",
        ...(isCompact && {
          pl: 1,
          minWidth: 0,
          fontSize: "0.8125rem",
          "& .MuiButton-startIcon": {
            marginRight: 0.5,
          },
        }),
      }}
    >
      {isInviteMode ? t("shareButton.invite") : t("shareButton.share")}
    </Button>
  );
}

ShareButton.propTypes = {
  fullWidth: PropTypes.bool,
  isInviteMode: PropTypes.bool,
  compact: PropTypes.bool,
  shareData: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
};
